const strings = {
	login: {
		login: 'Entrar',
		singnup: 'Registrar',
		userPlaceholder: 'Usuário',
		userLabel: 'Usuário',
		passwordPlaceholder: 'Senha',
		passwordLabel: 'Senha',
		remember: 'Lembrar-se',
		or: 'ou',
		agreeTerms: 'Concordo com os termos e políticas.',
		confirmPasswordLabel: 'Conforimar senha',
		confirmPasswordPlaceholder: 'confirmar senha',
	},
	error: {
		fieldsRequired: 'Por favor, preencha todos os campos obrigatórios!',
		invalidLogin: 'Login inválido, tente novamente!',
		passwordError: 'Senhas não compatíveis! Por favor verifique.',
	},
};

export default strings;
